import { Pipe, PipeTransform } from '@angular/core';
import { isDefined } from '../services/utils/utilities';

@Pipe({
  name: 'noComma'
})
export class NoCommaPipe implements PipeTransform {

  /**
   * Removes commas from a number.
   * @param num number to edit.
   * @returns string of number without commas.
   */
  public transform(num: number): string {
      return isDefined(num) ? num.toString().replace(/,/g, '') : '';
  }
}
